import { Injectable } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { MarketHelpConfig } from '@frontend/sports/common/client-config-data-access';
import { ExpiringCache, ExpiringCacheFactory } from '@frontend/sports/common/core/utils/expiring-cache';
import { Observable } from 'rxjs';

import { IMarketHelpResponse } from './model';

@Injectable({ providedIn: 'root' })
export class MarketHelpService {
    private cache: ExpiringCache;

    constructor(
        private apiService: ApiService,
        cacheFactory: ExpiringCacheFactory,
        config: MarketHelpConfig,
    ) {
        this.cache = cacheFactory.create(config.marketHelpCacheTimeout);
    }

    getHelp(key: string): Observable<IMarketHelpResponse> {
        const source = this.apiService.get<IMarketHelpResponse>('markethelp', {
            key,
        });

        return this.cache.getOrCreate(key, source);
    }
}
